import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center text-center px-6">
      <div>
        <div className="font-heading text-7xl font-bold text-gradient mb-4">404</div>
        <p className="text-muted-foreground mb-6">Page not found</p>
        <Link to="/" className="inline-flex items-center gap-2 h-11 px-6 rounded-full bg-foreground text-background font-semibold text-sm">
          Go home
        </Link>
      </div>
    </div>
  );
}
